import React from 'react';
import { useAuth } from '@/hooks/auth';
import OnboardingTemplate from '../OnboardingTemplate';

interface WelcomeStepProps {
  onNext: () => void;
}

const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext }) => {
  const { user } = useAuth();
  const fullName = user?.user_metadata?.full_name || user?.user_metadata?.name || 'there';

  return (
    <OnboardingTemplate>
      <h1 className="text-2xl font-bold mb-4">Hey, {fullName}!</h1>
      <p className="text-gray-700 mb-8">
        Let’s get your profile shining. Should only take a minute or two. Sound good?
      </p>
      <button
        className="bg-black text-white px-6 py-2 rounded hover:bg-gray-900 transition self-end"
        onClick={onNext}
      >
        Absolutely!
      </button>
    </OnboardingTemplate>
  );
};

export default WelcomeStep; 